import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { ModalFullscreen } from '@cian/ui-kit';
import * as React from 'react';
import { NewbuildingCarousel } from '@cian/frontend-newbuilding-carousel-component';
import { throttle } from 'throttle-debounce';
import { getCurrentOptions } from '../../shared/helpers';
import { prepareSliderOptions, prepareSlides } from '../../shared/mappers';
import { ECounterPosition } from '../../shared/types';
import { Footer } from './parts/Footer';
import { Header } from './parts/Header';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FullscreenCarousel = /*#__PURE__*/function (_React$Component) {
  function FullscreenCarousel() {
    var _this;
    _classCallCheck(this, FullscreenCarousel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FullscreenCarousel, [].concat(args));
    _defineProperty(_this, "state", _objectSpread({
      currentSlide: _this.props.defaultCurrentSlide || 1,
      options: getCurrentOptions(window.innerWidth, _this.props.media)
    }, prepareSlides(_this.props.slides, _this.props.defaultCurrentSlide)));
    _defineProperty(_this, "onSlideChange", function (params) {
      var onSlideChange = _this.props.onSlideChange;
      var currentSlide = params.currentSlide;
      var _prepareSlides = prepareSlides(_this.props.slides, currentSlide),
        slides = _prepareSlides.slides;
      _this.setState(function () {
        return {
          currentSlide: currentSlide,
          slides: slides
        };
      });
      if (onSlideChange) {
        onSlideChange(params);
      }
    });
    _defineProperty(_this, "onThumbnailClick", function (index) {
      _this.setState(function () {
        return {
          currentSlide: index
        };
      });
    });
    _defineProperty(_this, "updateOptions", function () {
      var media = _this.props.media;
      _this.setState(function () {
        return {
          options: getCurrentOptions(window.innerWidth, media)
        };
      });
    });
    _defineProperty(_this, "onWindowResize", function () {
      _this.updateOptions();
    });
    _defineProperty(_this, "throttledResizeHandler", throttle(150, _this.onWindowResize));
    return _this;
  }
  _inherits(FullscreenCarousel, _React$Component);
  return _createClass(FullscreenCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.throttledResizeHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.throttledResizeHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        defaultCurrentSlide = _this$props.defaultCurrentSlide,
        slides = _this$props.slides,
        media = _this$props.media;
      if (defaultCurrentSlide !== undefined && defaultCurrentSlide !== prevProps.defaultCurrentSlide) {
        this.setState(function () {
          return {
            currentSlide: defaultCurrentSlide
          };
        });
      }
      if (slides !== prevProps.slides) {
        this.setState(function () {
          return _objectSpread({}, prepareSlides(slides, defaultCurrentSlide));
        });
      }
      if (media !== prevProps.media) {
        this.setState(function () {
          return {
            options: getCurrentOptions(window.innerWidth, media)
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var onClose = this.props.onClose;
      var _this$state = this.state,
        currentSlide = _this$state.currentSlide,
        slides = _this$state.slides,
        options = _this$state.options,
        thumbnails = _this$state.thumbnails;
      var _prepareSliderOptions = prepareSliderOptions(options),
        firstPaintOptions = _prepareSliderOptions.firstPaintOptions,
        media = _prepareSliderOptions.media;
      var counterPosition = options.counterPosition,
        contentOptions = options.contentOptions,
        hideThumbnails = options.hideThumbnails;
      return /*#__PURE__*/_jsx(ModalFullscreen, {
        open: true,
        theme: "black",
        onClose: onClose,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles['container'],
          children: [/*#__PURE__*/_jsx(Header, {
            counter: counterPosition === ECounterPosition.HEADER ? {
              current: currentSlide,
              total: slides.length
            } : undefined,
            contentOptions: contentOptions,
            onCloseButtonClick: onClose
          }), /*#__PURE__*/_jsx("div", {
            className: styles['slider'],
            children: /*#__PURE__*/_jsx(NewbuildingCarousel, {
              slides: slides,
              firstPaintOptions: firstPaintOptions,
              media: media,
              onSlideChange: this.onSlideChange,
              defaultCurrentSlide: currentSlide,
              autofocus: true
            })
          }), /*#__PURE__*/_jsx(Footer, {
            contentOptions: contentOptions,
            thumbnails: hideThumbnails ? undefined : thumbnails,
            currentSlide: currentSlide,
            onThumbnailClick: this.onThumbnailClick
          })]
        })
      });
    }
  }]);
}(React.Component);